module.exports = __webpack_public_path__ + "static/img/publish.cb258e3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/publish.png
// module id = qrju
// module chunks = 1